// Im a human potato
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase.ts';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/custom.css';

import LoginPage from './pages/LoginPage';
import RegistrationPage from './pages/RegistrationPage';
import SubscriptionPage from './pages/SubscriptionPage';
import DashboardPage from './pages/DashboardPage';
import MenuPage from './pages/MenuPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsAuthenticated(true);

        // Check actual subscription status from Firestore
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            // Check if user has an active subscription
            const hasActivePlan = userData.subscription && userData.subscription.isActive;
            setHasSubscription(hasActivePlan);
          } else {
            // User document doesn't exist, no subscription
            setHasSubscription(false);
          }
        } catch (error) {
          console.error('Error checking subscription status:', error);
          // On error, assume no subscription for security
          setHasSubscription(false);
        }
      } else {
        setIsAuthenticated(false);
        setHasSubscription(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ?
              (hasSubscription ? <Navigate to="/dashboard" /> : <Navigate to="/subscription" />) :
              <LoginPage setIsAuthenticated={setIsAuthenticated} setHasSubscription={setHasSubscription} />
            }
          />
          <Route 
            path="/register" 
            element={
              isAuthenticated ? 
              <Navigate to="/subscription" /> : 
              <RegistrationPage setIsAuthenticated={setIsAuthenticated} setHasSubscription={setHasSubscription} />
            } 
          />
          <Route 
            path="/subscription" 
            element={
              !isAuthenticated ? 
              <Navigate to="/login" /> : 
              <SubscriptionPage setHasSubscription={setHasSubscription} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              !isAuthenticated ? 
              <Navigate to="/login" /> : 
              !hasSubscription ? 
              <Navigate to="/subscription" /> : 
              <DashboardPage setIsAuthenticated={setIsAuthenticated} setHasSubscription={setHasSubscription} />
            } 
          />
          <Route 
            path="/menu" 
            element={
              !isAuthenticated ? 
              <Navigate to="/login" /> : 
              <MenuPage setIsAuthenticated={setIsAuthenticated} />
            } 
          />
          <Route
            path="/forgot-password"
            element={
              isAuthenticated ?
              <Navigate to="/dashboard" /> :
              <ForgotPasswordPage />
            }
          />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;